import type { GatsbyBrowser } from 'gatsby'

import { initCookieRevokeContrast } from './src/helpers/cookieRevokeContrast'

let cleanupCookieRevokeContrast: (() => void) | undefined

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  cleanupCookieRevokeContrast?.()
  cleanupCookieRevokeContrast = initCookieRevokeContrast()
}

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  cleanupCookieRevokeContrast?.()
  cleanupCookieRevokeContrast = initCookieRevokeContrast()
}
